import { converterDataEua } from "_utils/Data";
import { TipoSolicitacaoPlaca } from "../constants/tipoSolicitacaoPlaca";
import { IFiltrosSolicitacao } from "../interfaces/IFiltrosSolicitacao";
import { IOrdenacao } from "../interfaces/IOrdenacao";

interface IParametrosBusca {
  tipo: TipoSolicitacaoPlaca;
  filtros: IFiltrosSolicitacao;
  pagina: number;
  limite: number;
  ordenacao: IOrdenacao;
}

export function montarParametrosSolicitacoes({
  tipo,
  filtros,
  pagina,
  limite,
  ordenacao,
}: IParametrosBusca): URLSearchParams {
  const parametros = new URLSearchParams({
    tipo,
    pagina: String(pagina),
    limite: String(limite),
    ordenarPor: ordenacao.campo,
    ordem: ordenacao.direcao,
  });
  const pdi = filtros.pdi.trim();
  const [inicio, fim] = filtros.periodoSolicitacao ?? [];

  if (pdi) parametros.set("pdi", pdi);
  if (filtros.idEmpresa) parametros.set("idEmpresa", String(filtros.idEmpresa));
  if (filtros.idDivisao) parametros.set("idDivisao", String(filtros.idDivisao));
  filtros.placa.forEach((placa) => parametros.append("placa", placa));
  filtros.idProcesso.forEach((idProcesso) =>
    parametros.append("idProcesso", idProcesso)
  );
  if (inicio) parametros.set("dataInicio", converterDataEua(inicio) as string);
  if (fim) parametros.set("dataFim", converterDataEua(fim) as string);

  return parametros;
}
